document.addEventListener('click',(e)=>{
    if(e.target.classList.contains('accordion-heading') || e.target.closest('.accordion-heading')) {
        const accordionItem = e.target.closest('.accordion-item');
        if(accordionItem) {
            const accordionContent = accordionItem.querySelector('.accordion-content');
            if(accordionContent) {
                if(accordionItem.classList.contains('open')) {
                    accordionContent.style.height = '0px';
                    accordionContent.style.paddingTop = '0px';
                    accordionContent.style.paddingBottom = '0px';
                    e.target.classList.remove('border-b1-light-grey');
                } else {
                    accordionContent.style.height = `${accordionContent.scrollHeight + 40}px`;
                    accordionContent.style.paddingTop = '20px';
                    accordionContent.style.paddingBottom = '20px';
                    e.target.classList.add('border-b1-light-grey');
                }
                accordionItem.classList.toggle('open');
            }
        }
    }
});